import { useEffect, useState } from 'react';

function getMatches(query) {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(query).matches;
}

/**
 * Subscribes to a CSS media query. The initial value is read from
 * `window.matchMedia` on the first client render so marketing layouts that
 * fork at a breakpoint do not flash the wrong structure. jsdom has no
 * matchMedia; those environments stay on the mobile-safe default.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => getMatches(query));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;

    const media = window.matchMedia(query);
    const onChange = () => setMatches(media.matches);
    onChange();
    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    }
    media.addListener(onChange);
    return () => media.removeListener(onChange);
  }, [query]);

  return matches;
}

export default useMediaQuery;
